<template>
  <label class="toggle-label" >
    <input
      type="checkbox"
      class="visually-hidden"
      :checked="modelValue"
      @change="onChange"
      role="switch"
      :aria-checked="modelValue"
      :id="id"
    />
    <div class="toggle-track" :class="{ active: modelValue }">
      <div class="toggle-thumb"></div>
    </div>
  </label>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: '',
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

function onChange(event) {
  const value = event.target.checked
  emit('update:modelValue', value)
  emit('change', value)
}
</script>

<style scoped>
.toggle-label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  user-select: none;
  position: relative;
  margin: 0;
  line-height: 0;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.toggle-track {
  width: 48px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  position: relative;
  transition: background-color 0.3s;
}

.toggle-track.active {
  background-color: #082A9D;
}

.toggle-thumb {
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
}

.toggle-track.active .toggle-thumb {
  transform: translateX(24px);
}

.dark .toggle-track {
  background-color: #444;
}
.dark .toggle-track.active {
  background-color: #0A4BFF;
}
.dark .toggle-thumb {
  background-color: #fff;
}
</style>
